import { render, staticRenderFns } from "./StepComparable.vue?vue&type=template&id=0a862424&scoped=true&"
import script from "./StepComparable.vue?vue&type=script&lang=js&"
export * from "./StepComparable.vue?vue&type=script&lang=js&"
import style0 from "./StepComparable.vue?vue&type=style&index=0&id=0a862424&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a862424",
  null
  
)

export default component.exports